import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SharedService } from "../../services/shared.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-update-password",
  templateUrl: "./update-password.component.html",
  styleUrls: ["./update-password.component.css"],
  providers: [SharedService],
})
export class UpdatePasswordComponent implements OnInit {
  updateForm: FormGroup;
  token: string;
  hide:boolean=true;
  hideConfirm:boolean=true;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.token = params["token"];
    });
    this.updateForm = this.formBuilder.group(
      {
        password: new FormControl(
          "",
          Validators.compose([
            Validators.required,
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
            ),
            Validators.maxLength(30),
          ])
        ),
        confirmPassword: new FormControl(
          "",
          Validators.compose([Validators.required, Validators.maxLength(30), this.passwordMatchValidator('password')])
        ),
      },
      
    );
  }
  passwordMatchValidator(password: string): ValidatorFn {
    return (control: FormControl) => {
      if (!control || !control.parent) {
        return null;
      }
      return control.parent.get(password).value === control.value ? null : { mismatch: true };
    };
  }

  password(formGroup: FormGroup) {
    const { value: password } = formGroup.get("password");
    const { value: confirmPassword } = formGroup.get("confirmPassword");
    return password === confirmPassword ? null : { passwordNotMatch: true };
  }

  updatePassword() {
    if(this.updateForm.invalid){
      return;
    }
    const password = this.updateForm.get("password").value;
    // this.sharedService
    //   .updatePassword(this.token, password)
    //   .subscribe((res: any) => {
    //     if (res.type === "Scholar") {
    //       Swal.fire({
    //         type: "success",
    //         title: res.message,
    //         timer: 1500,
    //         showCancelButton: false,
    //         showConfirmButton: false,
    //       }).then(() => {
    //         this.router.navigate(["/login/scholar"]);
    //       });
    //     }
    //     if (res.type === "Mentor") {
    //       Swal.fire({
    //         type: "success",
    //         title: res.message,
    //         timer: 1500,
    //         showCancelButton: false,
    //         showConfirmButton: false,
    //       }).then(() => {
    //         this.router.navigate(["/login/mentor"]);
    //       });
    //     }
    //   });
    this.sharedService.updatePassword(this.token, password)
  .subscribe(
    (res: any) => {
      if (res.type === "Scholar") {
        Swal.fire({
          type: "success",
          title: res.message,
          timer: 1500,
          showCancelButton: false,
          showConfirmButton: false,
        }).then(() => {
          this.router.navigate(["/login/scholar"]);
        });
      } else if (res.type === "Mentor") {
        Swal.fire({
          type: "success",
          title: res.message,
          timer: 1500,
          showCancelButton: false,
          showConfirmButton: false,
        }).then(() => {
          this.router.navigate(["/login/mentor"]);
        });
      }
    },
    (error) => {
      // Error handling here
      Swal.fire({
        type: "info",
        text: error.error.message,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  );

  }
}
